<template>
	<div class="settings" v-if="user">
		<div class="page-title">Настройки аккаунта</div>
		<div class="settings__groups">
			<div class="settings__group" v-if="user.has_password">
				<div class="settings__group-title">Смена пароля</div>
				<div class="settings__group-fields fields">
					<div class="fields__item field-input">
						<label class="field-input__label">Старый пароль</label>
						<input class="field-input__input" type="password" v-model="oldPassword">
					</div>
					<div class="fields__item field-input">
						<label class="field-input__label">Новый пароль</label>
						<input class="field-input__input" type="password" v-model="newPassword">
					</div>
					<div class="fields__item">
						<button class="btn btn--block" @click="resetPassword" :disabled="disableBtn">
							Изменить пароль
						</button>
					</div>
				</div>
			</div>

			<div class="settings__group" v-if="!user.has_password">
				<div class="settings__group-title">Установить пароль</div>
				<div class="settings__group-fields fields">
					<div class="fields__item field-input">
						<label class="field-input__label">Введите пароль</label>
						<input class="field-input__input" type="password" v-model="setPass">
					</div>
					<div class="fields__item">
						<button class="btn" @click="setPassword" :disabled="disableBtn">
							Сохранить пароль
						</button>
					</div>
				</div>
			</div>

			<div class="settings__group">
				<div class="settings__group-title">Соцсети</div>
				<div class="settings__group-fields fields">
					<div class="fields__item">
						<button v-if="!user.vkontakte" @click="$root.OAuth('vkontakte')" href="#"
							class="btn btn--block">
							<svg class="btn__icon">
								<use href="#svg-icon-vk"></use>
							</svg>
							<span>Привязать аккаунт Вконтакте</span>
						</button>
						<button v-if="user.vkontakte" disabled class="btn btn--block disabled">
							<svg class="btn__icon">
								<use href="#svg-icon-vk"></use>
							</svg>
							<span>{{ user.vkontakte.full_name ?? user.vkontakte.username }}</span>
						</button>
					</div>
					<div class="fields__item">
						<button v-if="!user.telegram" @click="$root.OAuth('telegram')" class="btn btn--block">
							<svg class="btn__icon">
								<use href="#svg-icon-tg"></use>
							</svg>
							<span>Привязать Телеграм</span>
						</button>

						<button v-if="user.telegram" disabled class="btn btn--block disabled">
							<svg class="btn__icon">
								<use href="#svg-icon-tg"></use>
							</svg>
							<span>{{ user.telegram.full_name ?? user.telegram.username }}</span>
						</button>
					</div>
					<div class="fields__item">
						<button v-if="!user.google" @click="$root.OAuth('google')" href="#" class="btn btn--block">
							<svg class="btn__icon">
								<use href="#svg-icon-google"></use>
							</svg>
							<span>Привязать Google</span>
						</button>
						<button v-if="user.google" disabled class="btn btn--block">
							<svg class="btn__icon">
								<use href="#svg-icon-google"></use>
							</svg>
							<span>{{ user.google.full_name ?? user.google.username }}</span>
						</button>
					</div>
					<div class="fields__item">
						<button v-if="!user.mailru" @click="$root.OAuth('mailru')" href="#" class="btn btn--block">
							<svg class="btn__icon">
								<use href="#svg-icon-mailru"></use>
							</svg>
							<span>Привязать mail.ru</span>
						</button>
						<button v-if="user.mailru" disabled class="btn btn--block">
							<svg class="btn__icon">
								<use href="#svg-icon-mailru"></use>
							</svg>
							<span>{{ user.mailru.full_name ?? user.mailru.username }}</span>
						</button>
					</div>
					<div class="fields__item">
						<button v-if="!user.yandex" @click="$root.OAuth('yandex')" href="#" class="btn btn--block">
							<svg class="btn__icon">
								<use href="#svg-icon-yandex"></use>
							</svg>
							<span>Привязать yandex</span>
						</button>
						<button v-if="user.yandex" disabled class="btn btn--block">
							<svg class="btn__icon">
								<use href="#svg-icon-yandex"></use>
							</svg>
							<span>{{ user.yandex.full_name ?? user.yandex.username }}</span>
						</button>
					</div>
					<div class="fields__item">
						<button @click="$root.logout" href="#" class="btn btn--block  btn--red">
							Выйти из аккаунта
						</button>
					</div>
				</div>
			</div>

			<div class="settings__group settings__group--first-order">
				<div class="settings__group-fields fields">
					<div class="fields__item">
						<div class="btn disabled">
							Для вывода нужно отыграть: {{ user.wager }}
						</div>
						<div class="settings__note">
							<router-link to="/faq#wager-balance"><b>Правила отыгрыша</b></router-link>
						</div>
					</div>
					<div class="fields__item" v-if="user && user.rang">
						<router-link :to="{name: 'rang'}" tag="a" class="btn btn--block">
							Ваш ранг: {{ user.rang.title }}
						</router-link>
					</div>
				</div>
			</div>

			<div class="settings__group" v-if="!user.old_username">
				<div class="settings__group-title">Изменение никнейма</div>
				<div class="settings__group-fields fields">
					<div class="fields__item field-input">
						<label class="field-input__label">Введите никнейм</label>
						<input class="field-input__input" type="text" v-model="username">
					</div>
					<div class="fields__item">
						<button class="btn btn--block" @click="editUser" :disabled="disableBtn">
							Сменить никнейм
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>


    import {mapState} from "pinia";
	import {useUserStore} from "../../stores/User.js";

	export default {
        data() {
            return {
                oldPassword: null,
                newPassword: null,
                username: null,
                setPass: null,
                disableBtn: false,
            }
        },
        mounted() {
            if (!this.$cookie.get('token')) {
                this.$toast.error('Требуется авторизация');

                return this.$router.go(-1);
            }
        },

		computed: {
			...mapState(useUserStore, ['user'])
		},

        methods: {
            resetPassword() {
                if (!this.oldPassword) {
                    return this.$toast.error('Введите старый пароль');
                }

                if (!this.newPassword) {
                    return this.$toast.error('Введите новый пароль');
                }

                this.disableBtn = true;

                this.$root.axios.post('api/user/password/change', {
                    current_password: this.oldPassword,
                    new_password: this.newPassword
                }).then((response) => {
                    if (response.data.success) { 
                        this.$toast.success('Пароль успешно изменён');
                    }

                    this.disableBtn = false; 
                })
                .catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));

                    this.disableBtn = false;
                });
            },
            editUser() {
                if (!this.username) {
                    return this.$toast.error('Введите новый ник');
                }

                this.disableBtn = true;

                this.$root.axios.post('api/user/username', {
                    'username': this.username
                }).then((response) => {
                    const data = response.data;
                    if (data.success) {
                        this.$root.getUser();  
                        
                        this.$toast.success('Ник успешно изменён');
                    } else {
                        this.$toast.error(data.message);
                    }

                    this.disableBtn = false;
                })
                .catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));

                    this.disableBtn = false;
                });
            },
            setPassword() {
                if (!this.setPass) {
                    return this.$toast.error('Введите новый пароль');
                }

                this.disableBtn = true;

                this.$root.axios.post('api/user/password/set', {
                    password: this.setPass
                }).then((response) => {
                    if (response.data.success) {  
                        this.$root.getUser();  

                        this.$toast.success('Пароль успешно изменён');               
                    }

                    this.disableBtn = false; 
                })
                .catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                    
                    this.disableBtn = false;
                });
            },
        }
    }
</script>